import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, BuildingIcon, InfoIcon, PlusIcon, MoreHorizontalIcon, EditIcon } from 'lucide-react';
export function PayoutSettings() {
  const {
    t
  } = useTranslation('balance');
  const navigate = useNavigate();
  const merchantName = 'BilaBila Mart';
  // State for Minimum Balance section
  const [minBalanceEnabled, setMinBalanceEnabled] = useState(false);
  const [minBalanceAmount, setMinBalanceAmount] = useState('');
  const [descriptor, setDescriptor] = useState('');
  const isMinBalanceInvalid = minBalanceEnabled && (!minBalanceAmount || Number(minBalanceAmount) <= 0);
  return <div className="max-w-5xl mx-auto py-8 px-4" data-id="element-3428" data-mp="gd9zijf8r9ot">
      {/* Header */}
      <div className="flex items-center gap-3 mb-8" data-id="element-3429" data-mp="1ws1p6ol062uf">
        <button onClick={() => navigate('/settings')} className="p-2 -ml-2 text-gray-500 hover:text-gray-900 hover:bg-gray-100 rounded-full transition-colors" aria-label={t('pages.PayoutSettings.attrs.back_to_settings')} data-id="element-3430" data-mp="1wqqcu0dhrmrp">
          <ArrowLeftIcon size={20} data-id="element-3431" data-mp="2zhx8a1bh11l7" />
        </button>
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-3432" data-mp="2zkt85v6vq0ca">
          {t('pages.PayoutSettings.payout_settings')}
        </h1>
      </div>

      <div className="space-y-6" data-id="element-3433" data-mp="38jy3ksn59dk8">
        {/* SECTION 1: Settlement currencies and bank accounts */}
        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-3434" data-mp="2bu6zc1p1wc18">
          <div className="p-6 border-b border-gray-200" data-id="element-3435" data-mp="2grpalyqjj3ce">
            <h2 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-3436" data-mp="2gq4fa6wejgdh">
              {t('pages.PayoutSettings.settlement_currencies_and_bank_accounts')}
            </h2>
            <p className="text-sm text-gray-500" data-id="element-3437" data-mp="2pmn7fgwt7090">
              {t('pages.PayoutSettings.to_accumulate_a_balance_in_a')}
            </p>
          </div>

          <div className="overflow-x-auto" data-id="element-3438" data-mp="1x3g9gz70rn0r">
            <table className="w-full text-left border-collapse" data-id="element-3439" data-mp="1x254iw1u8982">
              <thead data-id="element-3440" data-mp="30dubs755uaum">
                <tr className="bg-gray-50/50 border-b border-gray-200" data-id="element-3441" data-mp="30dc50gkvge8g">
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider w-32" data-id="element-3442" data-mp="2vfiytnjkjk86">
                    {t('pages.PayoutSettings.currency')}
                  </th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3443" data-mp="3576r1qny95ap">
                    {t('pages.PayoutSettings.payout_bank_account')}
                  </th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider w-48" data-id="element-3444" data-mp="2cihu83txfm4r">
                    <div className="flex items-center gap-1.5" data-id="element-3445" data-mp="2qi0pvx5jx506">
                      {t('pages.PayoutSettings.payout_fee')}
                      <InfoIcon size={14} className="text-gray-400" data-id="element-3446" data-mp="2mhqlgoxeqmnf" />
                    </div>
                  </th>
                  <th className="px-6 py-3 w-24" data-id="element-3447" data-mp="1pf1sk176zg7"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-3448" data-mp="1rrdwgk9yflc">
                <tr className="hover:bg-gray-50/50 transition-colors" data-id="element-3449" data-mp="984oykd0tnlf">
                  <td className="px-6 py-4" data-id="element-3450" data-mp="e8aosntg2gel">
                    <div className="flex items-center gap-2" data-id="element-3451" data-mp="e9bx4kj2sosm">
                      <span className="text-sm font-medium text-gray-900" data-id="element-3452" data-mp="3vh7fn234jom2">
                        {t('pages.BalanceActivity.usd')}
                      </span>
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-[11px] font-medium bg-emerald-100 text-emerald-800" data-id="element-3453" data-mp="rzfeoy70fubq">
                        {t('pages.PayoutSettings.default')}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-3454" data-mp="i7jijsohiea5">
                    <div className="flex items-center gap-3" data-id="element-3455" data-mp="n7xewdgq3zsc">
                      <div className="w-8 h-8 rounded bg-gray-100 border border-gray-200 flex items-center justify-center flex-shrink-0" data-id="element-3456" data-mp="n6clir65amw2">
                        <BuildingIcon size={16} className="text-gray-500" data-id="element-3457" data-mp="1fp9qdcflfcue" />
                      </div>
                      <div className="flex items-center gap-2" data-id="element-3458" data-mp="3o6cf28kotr5u">
                        <span className="text-sm text-gray-900" data-id="element-3459" data-mp="3j6zll4zb9lua">
                          {t('pages.PayoutSettings.kasikorn_bank')}
                        </span>
                        <span className="text-sm text-gray-500 font-mono" data-id="element-3460" data-mp="3e8erlnanjyea">
                          ••••0536 / 7375-001
                        </span>
                        <span className="text-lg leading-none" title={t('pages.PayoutSettings.attrs.thailand')} data-id="element-3461" data-mp="arpn06umqyr9">
                          🇹🇭
                        </span>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-3462" data-mp="3s6mk9j0nodjn">
                    <span className="text-sm text-gray-600" data-id="element-3463" data-mp="3s5tmh7jocydn">
                      {t('pages.PayoutSettings.free')}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-3464" data-mp="ope89fsm07wu">
                    <div className="flex items-center justify-end gap-2" data-id="element-3465" data-mp="x03eziduf3oy">
                      <button className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors shadow-sm" data-id="element-3466" data-mp="x1y293cl77w7">
                        {t('pages.PayoutSettings.edit')}
                      </button>
                      <button aria-label="Row actions" className="p-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md transition-colors border border-transparent" data-id="element-3467" data-mp="1b0xqwb03nmsd">
                        <MoreHorizontalIcon size={18} aria-hidden="true" data-id="element-3468" data-mp="1or18goo1asbh" />
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="p-4 border-t border-gray-200 bg-gray-50/30" data-id="element-3469" data-mp="1yq03v5jsgrgj">
            <button className="text-sm font-medium text-indigo-600 hover:text-indigo-700 transition-colors" data-id="element-3470" data-mp="23ns54q6bppxe">
              {t('pages.PayoutSettings.add_a_settlement_currency')}
            </button>
          </div>
        </div>

        {/* SECTION 2: Minimum balance */}
        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-3471" data-mp="18yp353w56tcb">
          <div className="p-6 border-b border-gray-200" data-id="element-3472" data-mp="1nrsjx91wt31z">
            <h2 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-3473" data-mp="1ixy1e8y1iu4h">
              {t('pages.PayoutSettings.minimum_balance')}
            </h2>
            <p className="text-sm text-gray-500" data-id="element-3474" data-mp="1ws76scuiuq7l">
              {t('pages.PayoutSettings.keep_a_minimum_amount_in_your')}
            </p>
          </div>

          <div className="p-6" data-id="element-3475" data-mp="26ninh0phq7hz">
            <div className="flex items-start gap-4" data-id="element-3476" data-mp="26mhaursttcy5">
              <button type="button" role="switch" aria-checked={minBalanceEnabled} onClick={() => setMinBalanceEnabled(!minBalanceEnabled)} className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 mt-0.5 ${minBalanceEnabled ? 'bg-indigo-600' : 'bg-gray-200'}`} data-id="element-3477" data-mp="21p7e0r33xz0a">
                <span aria-hidden="true" className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${minBalanceEnabled ? 'translate-x-5' : 'translate-x-0'}`} data-id="element-3478" data-mp="298gkabgbhhl4" />
              </button>

              <div className="flex-1" data-id="element-3479" data-mp="24b7zs47p51gp">
                <label className="text-sm font-medium text-gray-900 cursor-pointer block" onClick={() => setMinBalanceEnabled(!minBalanceEnabled)} data-id="element-3480" data-mp="1qanixdlcdfpu">
                  {t('pages.PayoutSettings.keep_a_minimum_amount_in_your_2')}
                </label>
                <p className="text-sm text-gray-500 mt-0.5 mb-4" data-id="element-3481" data-mp="3pnrlnfl4y2wb">
                  {t('pages.PayoutSettings.we_will_adjust_your_payouts_so')}
                </p>

                {minBalanceEnabled && <div className="mb-4" data-id="element-3482" data-mp="28ejlfti35gs6">
                    <div className="relative max-w-xs" data-id="element-3483" data-mp="28fl8kwcdltq9">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-3484" data-mp="23n9yx1ru2tki">
                        <span className="text-gray-500 sm:text-sm" data-id="element-3485" data-mp="1ynxdmlgm1uk1">
                          {t('pages.BalanceActivity.usd')}
                        </span>
                      </div>
                      <input type="number" value={minBalanceAmount} onChange={e => setMinBalanceAmount(e.target.value)} className={`block w-full pl-12 pr-3 py-2 sm:text-sm rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 ${isMinBalanceInvalid ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500' : 'border-gray-300'}`} placeholder="0" data-id="element-3486" data-mp="1oqas3g4t34r3" />
                    </div>
                    {isMinBalanceInvalid && <p className="mt-2 text-sm text-red-600 flex items-center gap-1.5" data-id="element-3487" data-mp="3mlppnz51k0ps">
                        <InfoIcon size={14} data-id="element-3488" data-mp="3rd7q8m35jza8" />
                        {t('pages.PayoutSettings.the_amount_must_be_greater_than')}
                      </p>}
                  </div>}

                <button className="flex items-center gap-1.5 text-sm font-medium text-gray-400 hover:text-gray-600 transition-colors" data-id="element-3489" data-mp="33nvmi1qlgjfb">
                  <PlusIcon size={16} data-id="element-3490" data-mp="38lx3mh4gm8o5" />
                  {t('pages.PayoutSettings.add_another_currency')}
                </button>
              </div>
            </div>
          </div>

          <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-end gap-3" data-id="element-3491" data-mp="nxah8ggq8xdh">
            <button className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors shadow-sm" data-id="element-3492" data-mp="rxt8o9epk1f5">
              {t('pages.BalanceSummary.cancel')}
            </button>
            <button disabled={isMinBalanceInvalid} className={`px-4 py-2 text-sm font-medium text-white rounded-md transition-colors shadow-sm ${isMinBalanceInvalid ? 'bg-indigo-400 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700'}`} data-id="element-3493" data-mp="1h4zndw50ur1t">
              {t('pages.PayoutSettings.save')}
            </button>
          </div>
        </div>

        {/* SECTION 3: Payout statement descriptor */}
        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-3494" data-mp="y9j89nmu7lpe">
          <div className="p-6 border-b border-gray-200" data-id="element-3495" data-mp="1395mo0eej7zs">
            <h2 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-3496" data-mp="186nm906j4av4">
              {t('pages.PayoutSettings.payout_statement_descriptor')}
            </h2>
            <p className="text-sm text-gray-500" data-id="element-3497" data-mp="2jkstc221h0uo">
              {t('pages.PayoutSettings.select_a_statement_descriptor_for_payouts')}
            </p>
          </div>

          <div className="p-6 space-y-6" data-id="element-3498" data-mp="2yuvrzeqd1o1">
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 flex items-start gap-3" data-id="element-3499" data-mp="2zxjxzko4q09">
              <InfoIcon size={20} className="text-gray-500 flex-shrink-0 mt-0.5" data-id="element-3500" data-mp="3ubpiu3i9klb5" />

              <p className="text-sm text-gray-700 leading-relaxed" data-id="element-3501" data-mp="3pccwrkz7vi9m">
                {t('pages.PayoutSettings.you_can_set_a_custom_statement')}{' '}
                <button className="text-indigo-600 hover:text-indigo-800 hover:underline" data-id="element-3502" data-mp="3gcg314xyzt7p">
                  {t('pages.PayoutSettings.balances')}
                </button>
                {t('pages.PayoutSettings.overriding_this_accountlevel_setting')}
              </p>
            </div>

            <div data-id="element-3503" data-mp="19nkwlakbe8do">
              <label className="block text-sm font-medium text-gray-900 mb-2" data-id="element-3504" data-mp="19m01nju38nfa">
                {t('pages.PayoutSettings.statement_descriptor')}
              </label>
              <input type="text" value={descriptor} onChange={e => setDescriptor(e.target.value)} placeholder={`Example - ${merchantName}`} className="block w-full max-w-md px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" data-id="element-3505" data-mp="2z4gj3bgcyy81" />
            </div>
          </div>

          <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-end gap-3" data-id="element-3506" data-mp="3huepln4icj9k">
            <button className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors shadow-sm" data-id="element-3507" data-mp="3mu137xo901iw">
              {t('pages.BalanceSummary.cancel')}
            </button>
            <button className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 rounded-md transition-colors shadow-sm" data-id="element-3508" data-mp="3cu0jwbqdplep">
              {t('pages.PayoutSettings.save')}
            </button>
          </div>
        </div>
      </div>
    </div>;
}